import React from 'react';

import NewSingleSampleFlow, {
  ParentProps as SingleSampleModalProps,
} from 'cards/components/common/SingleSample/NewSingleSampleFlow';

const NewSingleSampleModal = ({
  cardNameList,
  cardSuiteUUIDList,
  cardUUIDList,
  entryPoint,
  flowName,
  isMagnet,
  originalModalOptions,
  selectedColorSet,
}: SingleSampleModalProps): JSX.Element => (
  <NewSingleSampleFlow
    cardNameList={cardNameList}
    cardSuiteUUIDList={cardSuiteUUIDList}
    cardUUIDList={cardUUIDList}
    entryPoint={entryPoint}
    flowName={flowName}
    isMagnet={isMagnet}
    originalModalOptions={originalModalOptions}
    selectedColorSet={selectedColorSet}
  />
);

export default NewSingleSampleModal;
